import { useState, useEffect } from "react";
import styles from "./OnlineStartTimer.module.css";

export const OnlineStartTimer = ({
  setShowGameStartTimer,
  game,
  onGameStart,
  setShowMenuOverlay,
}) => {
  const [time, setTime] = useState(3);
  const [timerId, setTimerId] = useState(null);

  useEffect(() => {
    const id = setInterval(() => {
      setTime((previous) => {
        return previous - 1;
      });
    }, 900);
    setTimerId(id);
    game?.sounds?.countingSound?.play();
  }, [game]);

  useEffect(() => {
    if (time === 0) {
      clearTimeout(timerId);
      // Call the custom game start handler FIRST
      onGameStart();
      // Then hide timer
      setShowGameStartTimer(false);
    }
  }, [time, timerId, setShowGameStartTimer, onGameStart]);

  useEffect(() => {
    const startTimerOutOfFocus = (event) => {
      // In online mode, we might want different behavior for focus loss
      // For now, keeping similar to original
      setShowMenuOverlay?.(true);
    };

    window.addEventListener("blur", startTimerOutOfFocus);
    return () => {
      window.removeEventListener("blur", startTimerOutOfFocus);
    };
  }, [setShowMenuOverlay]);

  return (
    <section className={styles.startTimerSection}>
      <p className={styles.time}>{time}</p>
    </section>
  );
};
